import getFeatureFlags from 'helpers/getFeatureFlags';

import { isNil } from 'lodash-es';

export const REWARDS_ELIGIBLE_COUNTRIES = ['us', 'ca'] as const;

export async function isRewardsCountry(userCountry: string | undefined | null): Promise<boolean> {
  const flags = await getFeatureFlags();
  if (!flags.enable_region_lock_na_rewards) return true;

  if (isNil(userCountry)) return false;
  const trimmed = userCountry.trim();
  if (trimmed === '') return false;

  return REWARDS_ELIGIBLE_COUNTRIES.some((country) => country === trimmed.toLowerCase());
}
